import React, { useEffect, useState, useRef } from 'react'
import { getAdminCardData } from './Partials/constants'
import MetricCard from './Partials/MetricCard'
import CardDropdown from './Partials/CardDropdown'
import {
  AdminDashboardContainer,
  DashboardHeader,
  DashboardTitle,
  DashboardSubtitle,
  MetricsGrid,
  LoadingSpinner,
  DarkBlueHeader,
  HeaderTitle,
  HeaderSubtitle,
  HeaderControls,
  TimeIndicator,
  RefreshButton,
  DashboardContent,
} from './Partials/styles'

const AdminDashboard = ({
  getAdminDashboardMetrics,
  adminDashboardMetrics,
  loading,
}) => {
  const [cardData, setCardData] = useState([])
  const [selectedCardType, setSelectedCardType] = useState(null)
  const [activeCount, setActiveCount] = useState(0)
  const dashboardRef = useRef(null)

  useEffect(() => {
    getAdminDashboardMetrics()
  }, [])

  // Auto-refresh every 60s so the live "Online" counts stay current
  useEffect(() => {
    const interval = setInterval(() => {
      getAdminDashboardMetrics()
    }, 60 * 1000) // 60 seconds

    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    if (adminDashboardMetrics && Object.keys(adminDashboardMetrics).length > 0) {
      const response = getAdminCardData(adminDashboardMetrics)
      setCardData(response)
    }
  }, [adminDashboardMetrics])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dashboardRef.current && !dashboardRef.current.contains(event.target)) {
        setSelectedCardType(null)
      }
    }

    if (selectedCardType) {
      document.addEventListener('mousedown', handleClickOutside)
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }
  }, [selectedCardType])

  const handleCardClick = (cardType, count) => {
    setSelectedCardType(cardType)
    setActiveCount(count)
  }

  const handleCloseDropdown = () => {
    setSelectedCardType(null)
  }

  const handleRefresh = () => {
    setSelectedCardType(null)
    setActiveCount(0)
    getAdminDashboardMetrics()
  }

  if (loading) {
    return (
      <AdminDashboardContainer>
        <LoadingSpinner>Loading dashboard metrics...</LoadingSpinner>
      </AdminDashboardContainer>
    )
  }

  return (
    <AdminDashboardContainer ref={dashboardRef}>
      <DarkBlueHeader>
        <div>
          <HeaderTitle>Admin Dashboard</HeaderTitle>
          <HeaderSubtitle>
            Overview of active corporates and institutes
          </HeaderSubtitle>
        </div>
        <HeaderControls>
          <TimeIndicator>Active now</TimeIndicator>
          <RefreshButton onClick={handleRefresh}>
            Refresh
          </RefreshButton>
        </HeaderControls>
      </DarkBlueHeader>
      
      <DashboardContent>
        <MetricsGrid>
          {cardData.map(card => (
            <MetricCard
              key={card.key}
              icon={card.icon}
              text={card.text}
              totalValue={card.totalValue}
              activeValue={card.activeValue}
              color={card.color}
              onCardClick={handleCardClick}
              clicked={selectedCardType === (
                card.text.toLowerCase().includes('corporate') ? 'corporate' : 
                card.text.toLowerCase().includes('institute') ? 'institute' : 
                card.text.toLowerCase().includes('admin') ? 'admin' :
                card.text.toLowerCase().includes('student') ? 'student' : null
              )}
            />
          ))}
        </MetricsGrid>
        
        {selectedCardType && (
          <CardDropdown 
            type={selectedCardType}
            activeCount={activeCount}
            onClose={handleCloseDropdown}
          />
        )}
      </DashboardContent>
    </AdminDashboardContainer>
  )
}

export default AdminDashboard
